<template>
    <div>
        <button
            class="new-btn btn--sec-pine-white request-visit"
            id="request-visit-button"
            type="button"
            @click="handleClick"
        >
            {{ $t("ficha_nueva.request_visit") }}
        </button>
    </div>
</template>

<script>
export default {
    name: "Visit",
    props: {
        accommodation: Object,
        isLoggedIn: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleClick() {
            // Dejar la decisión de UI (modal o login) al componente padre (BookingDetails)
            this.$emit('request-visit');
        }
    }
};
</script>

<style lang="scss" scoped>
@import "@/new-assets/styles";

.request-visit {
    width: 100%;
    font-size: 1.2em;
    font-weight: bold;
}
</style>
